"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogContentText_1 = __importDefault(require("@material-ui/core/DialogContentText"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const react_1 = __importDefault(require("react"));
const common_1 = require("./common");
const InfoModal = ({ open, message, title, onClose }) => {
    return (react_1.default.createElement(Dialog_1.default, { TransitionComponent: common_1.SlideUp, open: open, onClose: onClose, fullWidth: true, maxWidth: "sm" },
        react_1.default.createElement(DialogTitle_1.default, null, title),
        react_1.default.createElement(DialogContent_1.default, null, message && typeof message === 'string' ? (react_1.default.createElement(DialogContentText_1.default, null, message)) : (message))));
};
exports.default = InfoModal;
//# sourceMappingURL=InfoModal.js.map